export enum Environments {
    DEV = 'dev',
    DEV2 = 'dev2',
    QA = 'qa',
    QA2 = 'qa2',
    STAGING = 'staging',
    LOCAL = 'local',
    PROD = 'prod',
}
